import { Link, NavLink, Outlet } from 'react-router-dom';
import { useApp } from '../app/AppContext';
import { getTranslation } from '../localization/translations';
import { audioService } from '../services/audio';
import { PwaUpdatePrompt } from './PwaUpdatePrompt';

export function Shell() {
  const { settings, progress } = useApp(); const t = getTranslation(settings.language); const stars = progress?.totalStars ?? 0;
  const activateAudio = () => { void audioService.activate(); };
  return <div className="app-shell" onPointerDownCapture={activateAudio} onKeyDownCapture={activateAudio}>
    <header className="topbar"><Link to="/" className="brand"><img src="/LittleDragon.png" alt="nagakeciks kids" className="app-logo"/><span>nagakeciks <b>kids</b></span></Link><nav aria-label="Main navigation">
      <NavLink to="/" end>🎮 <span>{t.games}</span></NavLink><NavLink to="/rewards">⭐ <span>{t.rewards}</span></NavLink><NavLink to="/parents">⚙️ <span>{t.parents}</span></NavLink>
    </nav><Link className="star-pill" to="/rewards" aria-label={`${stars} ${t.stars}`}>⭐ {stars}</Link></header>
    <main><Outlet /></main><PwaUpdatePrompt language={settings.language}/><footer><span>🌈</span> nagakeciks kids · {t.tagline} <span>🌈</span></footer>
  </div>;
}
